import React from 'react'

function Header() {
    return (
        <div className='auteco_header'></div>
    )
}

export default Header